import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import LogoHeader from "layout/MainLayout/Header/LogoHeader";
import ContentPage from "./ContentPage";

import { Box } from "@mui/material";
import { useEffect } from "react";

const LandingPage = () => {
  useEffect(() => {
    document.title = "CEEW";
  }, []);
  return (
    <Box>
      <LogoHeader />
      <ContentPage />
    </Box>
  );
};

export default LandingPage;
